module.exports = __webpack_public_path__ + "media/images/emblems/Gletterens-coat_of_arms-6c77b4b2de585f59ea94873fcfe86e06.svg";